import { render, staticRenderFns } from "./DiscountListTable.vue?vue&type=template&id=09c3146e&"
import script from "./DiscountListTable.vue?vue&type=script&lang=js&"
export * from "./DiscountListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports